import { Button, Stack, TextField } from "@mui/material";
import { useFieldArray, useFormContext } from "react-hook-form";

const RHFStringArrayField = ({ name, label }) => {
  const { control, register } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name,
  });

  return (
    <Stack spacing={2}>
      <label>{label}</label>
      {fields.map((field, index) => (
        <Stack key={field.id} direction="row" spacing={1} alignItems="center">
          <TextField
            {...register(`${name}.${index}`)}
            label={`Include ${index + 1}`}
            fullWidth
          />
          <Button
            variant="outlined"
            color="error"
            onClick={() => remove(index)}
          >
            Remove
          </Button>
        </Stack>
      ))}
      <Button variant="outlined" onClick={() => append("")}>
        Add Include
      </Button>
    </Stack>
  );
};

export default RHFStringArrayField;
